export default __webpack_public_path__ + "static/media/consult.a26f5069.png";